import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";
import { FA } from "components/FA";
import * as Yup from "yup";
import { useQuery } from "hooks";

import { modalService, alertService } from "services";

const NoteForm = ({ responseId, close, isModal = false }) => {
  const { resultset, actions } = useQuery();
  const response = resultset.find((r) => r.id === responseId);
  const history = useHistory();
  const initialValues = {
    note: response.note,
  };
  const validationSchema = Yup.object().shape({
    note: Yup.string(),
  });

  function onSubmit(fields, { setStatus, setSubmitting }) {
    setStatus();
    actions
      .note(responseId, fields.note)
      .then((response) => {
        alertService.success(`Note for "${response.title}" saved`, {
          keepAfterRouteChange: true,
        });
        if (typeof close === "function") {
          close();
        } else {
          history.push("/");
        }
      })
      .catch((error) => {
        setSubmitting(false);
        alertService.error(error);
      });
  }
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <h3 className="card-header">
            Personal Note
            {isModal && (
              <FA
                title="Close"
                onClick={() => close()}
                icon="times"
                size="xs"
              />
            )}
          </h3>
          <div className="card-body">
            <div className="form-group">
              <Field
                name="note"
                component="textarea"
                className={
                  "form-control" +
                  (errors.name && touched.name ? " is-invalid" : "")
                }
              />
              <ErrorMessage
                name="note"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary"
              >
                {isSubmitting && (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                )}
                Save
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const openNoteFormModal = (responseId) =>
  modalService.open({
    id: "note",
    children: (
      <NoteForm
        responseId={responseId}
        isModal={true}
        close={() => modalService.close("note")}
      />
    ),
  });

export { NoteForm, openNoteFormModal };
